import { render, staticRenderFns } from "./flv-player.vue?vue&type=template&id=32117844"
import script from "./flv-player.vue?vue&type=script&lang=js"
export * from "./flv-player.vue?vue&type=script&lang=js"
import style0 from "./flv-player.vue?vue&type=style&index=0&id=32117844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports